module.exports = __webpack_public_path__ + "img/ctrl-sqrt-swap-stub-mid-1.23319a7c.svg";